import { Box, Typography } from "@mui/material";
import MainWrapper from "../../components/helpers/MainWrapper";
import Habits from "../../images/habits.jpg";
import Effects from "../../images/effects.jpg";
import SideBar from "../../components/sidebar";

const ProductEffect2 = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <SideBar />
      <MainWrapper>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2.5rem",
          }}
        >
          <Typography
            variant="h2"
            fontSize={{ xs: "1.2rem", md: "1.8rem" }}
            color="#33636E"
            fontWeight="bold"
          >
            تأثیر محصولات سارودی در پایداری زیست محیطی :
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
            }}
          >
            <Box
              sx={{
                width: { xs: "50%", lg: "520px", xl: "680px" },
              }}
            >
              <img width="100%" height="100%" src={Habits} alt="habits" />
            </Box>
            <Box
              sx={{
                width: { xs: "30%", lg: "340px", xl: "400px" },
              }}
            >
              <img width="100%" height="100%" src={Effects} alt="effects" />
            </Box>
          </Box>
          <Typography
          textAlign="justify"
            sx={{
              fontSize: { xs: "12px", lg: ".8rem", xl: ".9rem" },
              maxWidth: { xs: "85%", md: "100%" },
              color: "#2E2E2E",
              textAlign: "justify",
            }}
          >
            میزان مصرف متریال‌های پلاستیکی در محصولات "مایع شوینده" با بسته‌بندی
            های کمتر از 1 لیتر، به مراتب بیشتر از محصولات مشابه‌ای است که حجم
            بسته‌بندی آن‌ها 4 لیتر یا بیشتر است. یکی از دلایل این واقعیت، وجود
            پمپ یا در‌پوش‌های چندتکه در بسیاری از نوع این محصولات می‌باشد که در
            مقایسه با مدل های 4لیتری، آنان فقط دارای یک درپوش ساده و معمولی
            هستند که مواد اولیه کمتری برای تولید آن استفاده شده است. به طور
            متوسط حجم 12 عدد مایع شوینده در بسته‌بندی های 300 سی‌سی، با یک 1 عدد
            از این نوع محصول با بسته‌بندی 4 لیتر، برابری می‌کند، اما حجم استفاده
            از متریال های پلاستیکی در 12 عدد مایع شوینده در بسته‌بندی 300 سی‌سی،
            35% بیشتر از یک مایع شوینده در بسته‌بندی 4 لیتری می‌باشد.
            <br />
            <span>
              در هسته تلاش‌های سارودی برای کمک در ساخت جهانی پایدار، جامایع‌های
              سارودی نمادی از مسئولیت‌پذیری نسبت به محیط زیست هستند. سارودی با
              ترویج مصرف‌کنندگان به اضافه کردن عادت‌های پایدار در سبک زندگی
              جامعه، سعی به آشکار کردن این واقعیت دارد که همواره عادت‌های کوچک،
              تاثیرات بزرگی به همراه دارند...
            </span>
          </Typography>
        </Box>
      </MainWrapper>
    </Box>
  );
};

export default ProductEffect2;
